import useStore from "../../../store"
import { useIsMobile } from "../../../hooks/useIsMobile"
import { Tabs } from '@chakra-ui/react'
import Notes from "../Notes/Notes"
import ReserveInfoBody from "../Reserve/ReserveInfoBody"
import DealerInfo from "./DealerInfo"
import Spinner from "../../common/Spinner"
import AmDealerUnits from "./AmDealerUnits"
import NearbyDealers from "./NearbyDealers"
import { useEffect } from "react"
import { humanize } from "../../../utilities/stringUtilities"
import { colors } from "../../../utilities/colors"
import { amNotesTouchesEnabled } from "../../../utilities/featureFlags"
import FilesPage from "../Apps/Files/FilesPage"
import DealerTransactions from "./Transactions/DealerTransactions"

export default function AmDealerDashboardSidePanel({ dealerId }) {
  const isMobile = useIsMobile()
  const dealer = useStore((state) => state.dealer)
  const fetchNearbyDealers = useStore((state) => state.fetchNearbyDealers)
  const nearbyDealerTableFilterParams = useStore((state) => state.nearbyDealerTableFilterParams)
  const nearbyDealerFilterAttribute = useStore((state) => state.nearbyDealerFilterAttribute)
  const fetchDealerDocuments = useStore((state) => state.fetchDealerDocuments)
  const fetchPeople = useStore((state) => state.fetchPeople)

  const TABS = amNotesTouchesEnabled
  ? ["units", "reserves", "notes_&_touches", "nearby_dealers", "files", "transactions"]
  : ["units", "reserves", "nearby_dealers", "files", "transactions"]

  useEffect(() => {
    if (dealer) {
      fetchNearbyDealers(dealer?.attributes.lat, dealer?.attributes.lng, '100', nearbyDealerTableFilterParams)
    }
  }, [dealer, nearbyDealerTableFilterParams, nearbyDealerFilterAttribute])

  useEffect(() => {
    fetchDealerDocuments(dealerId)
    fetchPeople(dealerId)
  }, [dealerId])

  return (
    <>
    {dealer ?
      <div className="w-full">
      <Tabs.Root variant='soft-rounded' defaultValue={isMobile ? "info" : "units"} lazyMount unmountOnExit>
        <Tabs.List
          className="w-full flex flex-wrap justify-start bg-grey-900"
          position={'sticky'}
          top={'0'}
          zIndex={isMobile ? 100 : 1000}
          pt={isMobile ? 1 : 3}
        >
          {isMobile && <Tabs.Trigger data-testid='info-tab' value = "info" _selected={{ color: colors.green, bg: colors.grey900 }} color={colors.grey100} mx={3}>Info</Tabs.Trigger>}
          {TABS.map((tab, index) =>
            <Tabs.Trigger
              data-testid={`${tab}-tab`}
              value={tab}
              _selected={{ color: colors.green, bg: colors.grey900 }}
              color={colors.grey100}
              mx={3}
            >
              {humanize(tab)}
            </Tabs.Trigger>
          )}
        </Tabs.List>
        {isMobile &&
          <Tabs.Content p={0} value="info">
            <div data-testid='dealer-info'>
              <DealerInfo dealerId={dealerId}/>
            </div>
          </Tabs.Content>
        }
        <Tabs.Content p={0} value="units">
          <div data-testid='units'>
            <AmDealerUnits />
          </div>
        </Tabs.Content>
        <Tabs.Content p={0} value="reserves">
          <div data-testid='reserve-information'>
            <ReserveInfoBody />
          </div>
        </Tabs.Content>
        {amNotesTouchesEnabled &&
          <Tabs.Content p={0} value="notes_&_touches">
            <div data-testid='notes' className="bg-grey-900 rounded">
              <Notes type="dealers" id={dealerId} />
            </div>
          </Tabs.Content>
        }
        <Tabs.Content p={0} value="nearby_dealers">
          <div data-testid='nearby-dealers' className="bg-grey-900 rounded">
            <NearbyDealers id={dealerId} />
          </div>
        </Tabs.Content>
        <Tabs.Content p={0} value="files">
          <div data-testid='files'>
            <FilesPage dealerId={dealerId}/>
          </div>
        </Tabs.Content>
        <Tabs.Content p={0} value="transactions">
          <div data-testid='transactions'>
            <DealerTransactions/>
          </div>
        </Tabs.Content>
      </Tabs.Root>
      </div> :
      <div className="flex justify-center pt-3 w-full">
        <Spinner />
      </div>
    }
    </>
  )
}